import { render } from "./ClassificationDataCom.vue?vue&type=template&id=35875371&scoped=true"
import script from "./ClassificationDataCom.vue?vue&type=script&lang=js"
export * from "./ClassificationDataCom.vue?vue&type=script&lang=js"

import "./ClassificationDataCom.vue?vue&type=style&index=0&id=35875371&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35875371"]])

export default __exports__